import { render, staticRenderFns } from "./CustomPageCard.vue?vue&type=template&id=af727aa6&"
import script from "./CustomPageCard.vue?vue&type=script&lang=js&"
export * from "./CustomPageCard.vue?vue&type=script&lang=js&"
import style0 from "./style.module.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports